import cx from 'classnames';
import React, { forwardRef } from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface OverflowFlexBoxProps extends BoxProps {
  innerClassName?: string;
  scrollableClassName?: string;
}

const FormItem = forwardRef<HTMLDivElement, OverflowFlexBoxProps>(
  ({ className, innerClassName, scrollableClassName, children, ...rest }, ref) => {
    return (
      <Box className={cx(styles['overflowing-flex-box'], className)} flex={1} {...rest}>
        <div className={cx(styles['inner'], innerClassName)}>
          <div className={cx(styles['scrollable'], scrollableClassName)} ref={ref}>
            {children}
          </div>
        </div>
      </Box>
    );
  },
);

export default FormItem;
